import React from 'react'

const LinkedIn = () => {
  return (
    <div className="text-6xl font-bold">
        LinkedIn
    </div>
  )
}

export default LinkedIn